import { createSlice } from "@reduxjs/toolkit";
import axios from "src/utils/axios";
import {
  changeState,
  editorActions,
  getvdiInfo,
  newTokenUpdate,
  removePresenterAccess,
  resetCursorPosition,
} from "./editor";
import { removeMachineByDeviceId, setLastRequestTime } from "./persistStore";
import natsService from "src/services/NatsService";
import { VdiServiceActions, handleShowMaxLimitDisclaimer } from "./events/Resource_Assignment";
import { setHeaderTabs, setDropDownTabs, setActiveTab } from "./AvToolbar";
import { findMachineName } from "src/constants/commonFuntion";
interface IData {
  accessFrom: string;
  contextId: string;
  emailId: string;
  id: string;
  isInvited: boolean;
  lastReadMessage: number;
  left: boolean;
  lock: boolean;
  name: string;
  options: {
    canDelete: boolean;
    canEdit: boolean;
  };
  properties: {
    devicesAssigned: [{ access: string; device: string }];
    status: "";
  };

  removed: boolean;
  role: {
    id: string;
    name: string;
  };
  threadId: number;
}

interface IAccess {
  participant_id: string;
  access: string;
  name: string;
  avatar?: string;
}
interface ISystemSpec {
  active: boolean;
  cpu_count: number;
  createdTime: string;
  ram: number;
  raw_format: [];
  ssd: string;
}
interface IServiceAccess {
  access: IAccess[];
  id: string;
  name: string;
  properties: {
    groupId: string;
    groupName: string;
    location: string;
    os: string;
    provider: string;
    systemSpecs: ISystemSpec[];
    planId?: string;
  };
  state: string;
  dns: {
    address: string;
    ip: string;
  };
  timeline: {
    instantiationTime: string;
    lastStarted: string;
  };
  billing: {
    code: string;
    total_cost: number;
  };
}
interface IActivityData {
  title: string;
  message: string;
  type: string;
  operation: string;
  createdDate: string;
}

interface IPlan {
  id?: string;
  description?: string;
  costPerHour?: number;
  monthlyHours?: number;
}
interface ICloneVdi {
  openModal?: boolean;
  title?: string;
  plans?: IPlan[];
  selectedPlan?: string;
  selectedPlanDetails?: IPlan;
  selectedServiceId?: string;
  selectedGroupId?: string;
  currentPlanId?: string;
  currentPlanIndex?: number;
  loader?: boolean;
}

interface IAccessPermissionDialog {
  isLoading: boolean;
  isActivityAccessLoading: boolean;
  state: boolean;
  getPermission: IData[];
  serviceDeviceID: IServiceAccess[];
  ID: string;
  VDItype: string;
  AccessValue: boolean;
  accessChange: [];
  errorMessage: {
    active: boolean;
    message: string;
  };
  screenShareerrorMessage: {
    active: boolean;
    message: string;
  };
  revokeData: [];
  activity: {
    data: IActivityData[];
    metaData: {
      items: number;
      page: number;
      pages: number;
      pagesize: number;
    };
  };

  activityAccess: {
    data: IActivityData[];
    metaData: {
      items: number;
      page: number;
      pages: number;
      pagesize: number;
    };
  };
  notification: {
    active: boolean;
    message: string;
    color: string;
  };
  currentTab: number;
  ram_usage: number;
  cpu_usage: number;
  disk_usage: number;
  resizingMsg: {
    active: boolean;
    message: string;
  };
  vdiAccessAlert: {
    active: boolean;
    message: string;
    color: string;
  };
  accessPermissionBtnStatus: boolean;
  cloneVDI?: ICloneVdi;
  requestMachineLoader?: boolean;
  machineRequestDialog?: {
    open: boolean;
    data: any;
  };
  autoAssignDialog?: {
    open: boolean;
    participantData: any;
    groupId?: string;
  };
}

const initialState: IAccessPermissionDialog = {
  isLoading: false,
  isActivityAccessLoading: false,
  state: false,
  getPermission: [],
  serviceDeviceID: [],
  ID: "",
  VDItype: "",
  AccessValue: false,
  accessChange: [],
  errorMessage: {
    active: false,
    message: "",
  },
  screenShareerrorMessage: {
    active: false,
    message: "",
  },
  revokeData: [],
  activity: {
    data: [],
    metaData: {
      items: 0,
      page: 0,
      pages: 0,
      pagesize: 0,
    },
  },
  activityAccess: {
    data: [],
    metaData: {
      items: 0,
      page: 0,
      pages: 0,
      pagesize: 0,
    },
  },
  notification: {
    active: false,
    message: "",
    color: "",
  },
  currentTab: 0,
  ram_usage: 0,
  cpu_usage: 0,
  disk_usage: 0,
  resizingMsg: {
    active: false,
    message: "",
  },
  vdiAccessAlert: {
    active: false,
    message: "",
    color: "",
  },
  accessPermissionBtnStatus: false,
  cloneVDI: {
    openModal: false,
    title: "",
    plans: [],
    selectedPlan: "",
    selectedPlanDetails: {},
    selectedServiceId: "",
    selectedGroupId: "",
    currentPlanId: "",
    currentPlanIndex: null,
    loader: false,
  },
  requestMachineLoader: false,
  machineRequestDialog: {
    open: false,
    data: null
  },
  autoAssignDialog: {
    open: false,
    participantData: null
  }
};

const slice = createSlice({
  name: "accessPermissionDialog",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setActivityAccessLoading: (state, action) => {
      state.isActivityAccessLoading = action.payload;
    },
    accessPermissionDialog(state, action) {
      state.state = action.payload;
    },
    getPermission(state, action) {
      state.getPermission = action.payload;
    },
    deviceID(state, action) {
      state.serviceDeviceID = action.payload;
    },
    serviceID(state, action) {
      state.ID = action.payload;
    },
    VDItype(state, action) {
      state.VDItype = action.payload;
    },
    GiveAccess(state, action) {
      state.accessChange = action.payload;
    },
    AccessValue(state, action) {
      state.AccessValue = action.payload;
    },
    errorMessage(state, action) {
      state.errorMessage = action.payload;
    },
    screenShareerrorMessage(state, action){
      state.screenShareerrorMessage = action.payload;
    },
    revokeAccess(state, action) {
      state.revokeData = action.payload;
    },
    ActivityAPI(state, action) {
      state.activity = action.payload;
    },
    ActivityAccessAPI(state, action) {
      state.activityAccess = action.payload;
    },
    accessNotification(state, action) {
      state.notification = action.payload;
    },
    setCurrentTab(state, action) {
      state.currentTab = action.payload;
    },
    setRamCpuUsages(state, action) {
      state.ram_usage = action.payload.ram;
      state.cpu_usage = action.payload.cpu;
      state.disk_usage = action.payload.disk;
    },
    resizingNotification(state, action) {
      state.resizingMsg = action.payload;
    },
    resetSelectedMachineData(state) {
      state.serviceDeviceID = [];
      state.ID = "";
    },
    setVdiAccessAlert(state, action) {
      state.vdiAccessAlert = action.payload;
    },
    accessPermissionBtnStatus(state, action){
      state.accessPermissionBtnStatus = action.payload;
    },
    cloneVDI(state, action) {
      state.cloneVDI[action.payload.key] = action.payload.value;
    },
    resetCloneVDI(state) {
      state.cloneVDI = initialState?.cloneVDI;
    },
    setRequestMachineLoader(state, action) {
      state.requestMachineLoader = action.payload;
    },
    setMachineRequestDialog(state, action) {
      state.machineRequestDialog = action.payload;
    },
    setAutoAssignDialog(state, action) {
      state.autoAssignDialog = action.payload;
    },
  },
});

export const AccessPermissionActions = slice.actions;

export const reducer = slice.reducer;
const APP_BASE_URL = process.env.REACT_APP_API_URL;

export const AccessPermissionDialogStatus =
  (data: boolean) => async (dispatch) => {
    dispatch(slice.actions.accessPermissionDialog(data));
  };

export const getServicesPermission = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${APP_BASE_URL}/events/api/v1/participants?list=true`
    );
    dispatch(slice.actions.getPermission(response?.data?.data));
  } catch (error) {
    throw new Error(error);
  }
};
export const fetchAccessParticipantDetails =(machineID:string)=> async() => {
  if (!machineID) return;
  try{
    const response = await axios.get(
      `${APP_BASE_URL}/events/api/v1/participants/access-control/${machineID}`
    );
    if(response?.data?.status){
      return response?.data?.data;
    }
  }catch (error) {
    throw new Error(error as any);
  }
};
export const VDItype = (id) => async (dispatch) => {
  dispatch(slice.actions.VDItype(id));
};

export const AccessVDI = (id) => async (dispatch) => {
  dispatch(slice.actions.AccessValue(id));
};

export const deviceID =
  (id, reload = false, data: any = { device: "", access: "" }) =>
    async (dispatch) => {
      try {
        if (!reload) {
          dispatch(slice.actions.setLoading(true));
        }
        const response = await axios.get(
          `${APP_BASE_URL}/service-management/api/v1/service?id=${id}`
        );

        dispatch(slice.actions.deviceID(response?.data?.data));
        dispatch(slice.actions.serviceID(id));
        if (data.device) {
          dispatch(
            getvdiInfo({
              ...data,
              ip: response?.data?.data[0]?.dns?.ip,
              address: response?.data?.data[0]?.dns?.address,
              os: response?.data?.data[0]?.properties?.os,
            })
          );
        } else {
          dispatch(
            getvdiInfo({
              device: id,
              access: "owner",
              ip: response?.data?.data[0]?.dns?.ip,
              address: response?.data?.data[0]?.dns?.address,
              os: response?.data?.data[0]?.properties?.os,
            })
          );
        }
        dispatch(storeCurrentTab(0));
      } catch (error) {
        throw new Error(error);
      } finally {
        dispatch(slice.actions.setLoading(false));
      }
    };

export const GiveAccess = (data, loadingStatus?: boolean) => async (dispatch) => {
  if(loadingStatus){
    dispatch(slice.actions.accessPermissionBtnStatus(true));
  }
  try {
    const response = await axios.post(`${APP_BASE_URL}/service-management/api/v1/access/give-access`, data);
    dispatch(slice.actions.GiveAccess(response?.data?.data));
    dispatch(getServicesPermission());
  } catch (error) {
    dispatch(
      slice.actions.errorMessage({
        active: true,
        message: error?.message,
      })
    );
    throw new Error(error);
  } finally {
    setTimeout(() => {
      dispatch(slice.actions.errorMessage({ active: false, message: "" }));
    }, 4000);
    dispatch(slice.actions.accessPermissionBtnStatus(false));
  }
};

export const revokeAccess = (data) => async (dispatch, getState) => {
  try {
    const presenterDevice = getState()?.editor?.vdiInfoRead?.device;
    if (presenterDevice && presenterDevice === data?.device) {
      dispatch(editorActions.setIsStoppingPresenter(true));
      await dispatch(removePresenterAccess(presenterDevice));
    }

    const response = await axios.put(
      `${APP_BASE_URL}/service-management/api/v1/access/revoke-access`,
      data
    );
    dispatch(slice.actions.revokeAccess(response?.data?.data));
  } catch (error) {
    throw new Error(error);
  }
};

export const ActivityAPI =
  (data, id, pageCount, pageNumber) => async (dispatch) => {
    try {
      dispatch(slice.actions.setLoading(true));
      const response = await axios.get(
        `${APP_BASE_URL}/service-management/api/v1/activity?type=${data}&serviceId=${id}&meta=${true}&pageSize=${pageCount}&page=${pageNumber}`
      );
      dispatch(slice.actions.ActivityAPI(response?.data));
    } catch (error) {
      throw new Error(error);
    } finally {
      dispatch(slice.actions.setLoading(false));
    }
  };

export const ActivityAccessAPI =
  (data, id, pageCount, pageNumber) => async (dispatch) => {
    dispatch(slice.actions.setActivityAccessLoading(true));
    try {
      const response = await axios.get(
        `${APP_BASE_URL}/service-management/api/v1/activity?type=${data}&serviceId=${id}&meta=${true}&pageSize=${pageCount}&page=${pageNumber}`
      );
      dispatch(slice.actions.ActivityAccessAPI(response?.data));
    } catch (error) {
      throw new Error(error);
    } finally {
      dispatch(slice.actions.setActivityAccessLoading(false));
    }
  };

export const AccessEnable = (data) => async (dispatch) => {
  if (data?.response?.data?.state === "STARTED") {
    dispatch(deviceID(data?.response?.data?.serviceId, true));
  }
};

export const NotificationMuteUnmute = (data, message) => async (dispatch) => {
  if (data === "MUTE") {
    dispatch(
      slice.actions.accessNotification({
        active: true,
        color: "success",
        message: message,
      })
    );
    setTimeout(() => {
      dispatch(
        slice.actions.accessNotification({
          active: false,
          message: "",
          color: "success",
        })
      );
    }, 3000);
  } else if (data === "UNMUTE") {
    dispatch(
      slice.actions.accessNotification({
        active: true,
        color: "success",
        message: `${name} have successfully unmuted you.`,
      })
    );
    setTimeout(() => {
      dispatch(
        slice.actions.accessNotification({
          active: false,
          message: "",
          color: "success",
        })
      );
    }, 3000);
  }
};

export const vdiAccessNotification = (data) => async (dispatch, getState) => {
  const isPresenting = getState()?.persistStore?.showNotificationData;
  if (isPresenting !== "present") {
    dispatch(
      slice.actions.setVdiAccessAlert({
        active: true,
        message: data,
        color: "success",
      })
    );
    setTimeout(() => {
      dispatch(
        slice.actions.setVdiAccessAlert({
          active: false,
          message: "",
          color: "success",
        })
      );
    }, 5000);
  }
};

export const TrainerNotification =
  (data, color = "success") =>
    async (dispatch) => {
      dispatch(
        slice.actions.accessNotification({
          active: true,
          color: color,
          message: data,
        })
      );
      setTimeout(() => {
        dispatch(
          slice.actions.accessNotification({
            active: false,
            message: "",
            color: "success",
          })
        );
      }, 3000);
    };

export const AccessNotification =
  (data, activeMachine, presenterVDI, ID) => async (dispatch, getState) => {
    if (
      data?.response?.data?.state === "STOPPING" ||
      data?.response?.data?.state === "STOPPED" ||
      data?.response?.data?.state === "RESIZING" ||
      data?.response?.data?.state === "DESTROYING" ||
      data?.response?.data?.state === "RESTARTING"
    ) {
      const affectedServiceId = data?.response?.data?.serviceId;
      const affectedMachine = activeMachine?.find(
        (m) => m.deviceId === affectedServiceId
      );
      if (affectedMachine) {
        dispatch(newTokenUpdate());
        dispatch(removeMachineByDeviceId(affectedServiceId));
        const user = getState()?.messages;
        dispatch(
          hideCursor(
            `service-collab-${affectedServiceId}`,
            user?.user_id,
            user?.name
          )
        );
      }
      if (presenterVDI?.device === data?.response?.data?.serviceId) {
        dispatch(removePresenterAccess(data?.response?.data?.serviceId));
      }
    }

    if (ID === data?.response?.data?.serviceId) {
      dispatch(deviceID(ID, true));
    }

    if (
      data?.response?.data?.action === "ACCESS_GRANTED" &&
      data?.response?.data?.updateUI
    ) {
      dispatch(
        slice.actions.accessNotification({
          active: true,
          color: "success",
          message: data?.response?.data?.message,
        })
      );
      setTimeout(() => {
        dispatch(
          slice.actions.accessNotification({
            active: false,
            message: "",
            color: "success",
          })
        );
      }, 3000);
    } else if (data?.response?.data?.action === "ACCESS_REVOKED") {
      if (data?.response?.data?.serviceId === ID) {
        dispatch(slice.actions.serviceID(""));
      }
      if (
        activeMachine?.length > 0 &&
        activeMachine.some((m) => m.deviceId === data?.response?.data?.serviceId)
      ) {
        const revokedServiceId = data?.response?.data?.serviceId;
        const { headerTabs, dropDownTabs } = getState().avToolbar;
        const newHeader = headerTabs.filter(
          (t) => !(t.type === "Machine" && t.deviceId === revokedServiceId)
        );
        const newDropDown = dropDownTabs.filter(
          (t) => !(t.type === "Machine" && t.deviceId === revokedServiceId)
        );
        dispatch(setHeaderTabs(newHeader));
        dispatch(setDropDownTabs(newDropDown));
        const activeTab = getState().avToolbar.activeTab;
        const machineName = `Machine (${findMachineName(revokedServiceId)})`;
        if (activeTab === machineName) {
          dispatch(setActiveTab("home"));
        }
        dispatch(removeMachineByDeviceId(revokedServiceId));
        const user = getState()?.messages;
        dispatch(
          hideCursor(
            `service-collab-${revokedServiceId}`,
            user?.user_id,
            user?.name
          )
        );
      }
      dispatch(
        slice.actions.accessNotification({
          active: true,
          color: "error",
          message: data?.response?.data?.message,
        })
      );
    }

    setTimeout(() => {
      dispatch(
        slice.actions.accessNotification({
          active: false,
          message: "",
          color: "success",
        })
      );
    }, 3000);

    if (data?.response?.data?.state === "RESIZING") {
      dispatch(
        slice.actions.resizingNotification({
          active: true,
          message: "Your machine is under upgrading..!",
        })
      );
      dispatch(changeState(false));
      setTimeout(() => {
        dispatch(
          slice.actions.resizingNotification({ active: false, message: "" })
        );
      }, 3000);
    }
  };

export const storeCurrentTab = (data) => async (dispatch) => {
  dispatch(slice.actions.setCurrentTab(data));
};

export const devicesUsage = (data) => async (dispatch) => {
  if (
    data?.response?.data?.ram_usage !== undefined &&
    data?.response?.data?.cpu_utilization !== undefined
  ) {
    dispatch(
      slice.actions.setRamCpuUsages({
        ram: data?.response?.data?.ram_usage || 0,
        cpu: data?.response?.data?.cpu_utilization || 0,
        disk: data?.response?.data?.disk_usage || 0,
      })
    );
  }
};

export const resetSelectedMachineData = () => (dispatch) => {
  dispatch(slice.actions.resetSelectedMachineData());
};

export const getUsage = (data, contextId?: string) => async () => {
  try {
    const config = contextId ? { headers: { contextId } } : {};
    await axios.get(`${APP_BASE_URL}/service-management/api/v1/service/usage/${data}`, config);
  } catch (error) {
    throw new Error(error);
  }
};

export const hideCursor =
  (serviceCollabId, userId, userName) => async (dispatch) => {
    natsService.publish(
      serviceCollabId,
      JSON.stringify({
        domain: "COLLAB_POINTER",
        intent: "UPDATE",
        response: {
          pid: userId,
          pname: userName,
          lc: {
            x: "-100px",
            y: "-100px",
          },
        },
      })
    );
    setTimeout(() => {
      natsService.unsubscribe(serviceCollabId);
      dispatch(resetCursorPosition());
    }, 3000);
  };

export const handleCollaborationApi = () => async () => {
  try {
    const response = await axios.patch(
      `${APP_BASE_URL}/events/api/v1/events/collaboration`
    );

    if (!response?.data?.status) {
      throw new Error(response?.data?.message || "Collaboration failed");
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const ErrorMessage = (data) => async (dispatch) => {
  dispatch(
    slice.actions.screenShareerrorMessage({
      active: true,
      message: data,
    })
  );
};

export const getPlansAPI = (data, enqueueSnackbar, currentPlanId) => async (dispatch) => {
  try {
    const response = await axios.get(`${APP_BASE_URL}/service-management/api/v1/cloud/plans?os=${data?.os}&provider=${data?.provider}&locations=${data?.location}`);

    if (response?.data?.status) {
      const rawList = response?.data?.data;
      const list = [];
      for (const k in rawList) {
        list.push(
          {
            id: rawList[k]?.id,
            description: rawList[k]?.description,
            costPerHour: rawList[k]?.properties?.costPerHour,
            monthlyHours: rawList[k]?.properties?.monthlyHours
          }
        );
      }
      dispatch(slice.actions.cloneVDI({
        key: "plans",
        value: list
      }));
      const index = list?.findIndex(item => item?.id === currentPlanId);
      dispatch(slice.actions.cloneVDI({
        key: "currentPlanIndex",
        value: index >= 0 ? index : 0
      }));

      // Use the filter method to get the object with the specified ID
      const filteredArray = list?.filter(obj => obj?.id === currentPlanId);
      dispatch(AccessPermissionActions.cloneVDI({
        key: "selectedPlanDetails",
        value: filteredArray[0],
      }));

    } else {
      throw new Error(response?.data?.message || "Failed to fetch plans");
    }
  } catch (error) {
    enqueueSnackbar(
      error?.message || error || "Failed to fetch plans", {
      variant: "error",
      preventDuplicate: true,
      autoHideDuration: 5000,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    }
    );
    throw new Error(error);
  }
};
export const CloneVDIAPI = (data, enqueueSnackbar) => async (dispatch) => {
  // loader
  dispatch(slice.actions.cloneVDI({
    key: "loader",
    value: true
  }));

  // payload for api
  const payload = {
    "name": data?.title,
    "properties": {
      "planId": data?.planId
    },
    "type": "virtual_desktop_infrastructure_browser",
    "clone": {
      "enabled": true,
      "serviceId": data?.serviceId
    }
  };

  try {
    const response = await axios.post(`${APP_BASE_URL}/events/api/v1/spaces`, payload);
    if (response?.data?.status) {
      dispatch(slice.actions.resetCloneVDI());
      enqueueSnackbar(response?.data?.message || "Machine Cloned successfully", {
        variant: "success",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
    } else {
      if (response?.data?.message === "This machine is more than your account limit") {
        dispatch(slice.actions.resetCloneVDI());
        dispatch(handleShowMaxLimitDisclaimer(true));
        dispatch(VdiServiceActions.disclaimerType("limit"));
      } else
        throw new Error(response?.data?.message || "Failed to clone machine");
    }
  } catch (error) {
    if (error?.message === "Insufficient Credits") {
      dispatch(slice.actions.resetCloneVDI());
      dispatch(handleShowMaxLimitDisclaimer(true));
      dispatch(VdiServiceActions.disclaimerType("credits"));
    } else {
      enqueueSnackbar(
        error?.message || error || "Failed to clone machine", {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      }
      );
      throw new Error(error);
    }
  } finally {
    dispatch(slice.actions.cloneVDI({
      key: "loader",
      value: false
    }));
  }
};

export const requestMachine = (enqueueSnackbar) => async (dispatch) => {
  try {
    dispatch(slice.actions.setRequestMachineLoader(true));
    const response = await axios.post(`${APP_BASE_URL}/events/api/v1/events/request-machine`);
    if (!response?.data?.status) {
      throw new Error(response?.data?.message || "Failed to request machine");
    }
    dispatch(setLastRequestTime(Date.now()));
  } catch (error) {
    enqueueSnackbar(
      error?.message || error || "Failed to request machine", {
      variant: "error",
      preventDuplicate: true,
      autoHideDuration: 5000,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    }
    );
    throw new Error(error);
  } finally {
    dispatch(slice.actions.setRequestMachineLoader(false));
  }
};

export default slice;
